import {setSlideinState, SlideInStateEnum} from "../../../core/components/slideIn/slideInSlice";
import {useAppSelector} from "../../../app/hooks";
import {Localizer} from "../../../infrastructure/localization/localizer";
import {
    kompetenceCardReducer,
    KompetenceCardState,
    scrollToActiveKompetence,
    setActiveKompetencePageTab,
    setActiveLaegekompetenceMeta,
    toggleLaegekompetenceListRefreshPing,
    toggleLaegekompetenceNotatChangedPing
} from "../cards/kompetenceCardSlice";
import {LaegekompetenceMeta} from "../../../core/sharedmodels/kompetence/laegekompetenceMeta";
import {KompetenceDetails} from "./kompetenceDetails";
import {SlideIn} from "../../../core/components/slideIn/slideIn";
import {isActiveTab, Tab, Tabs} from "../../../core/components/Tabs/Tabs";
import {KompetenceStatusButton} from "../../../core/componentsPage/kompetence/kompetenceStatusButton";
import React, {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {
    CreateLaegekompetenceNotat
} from "../../../core/componentsPage/notat/kompetenceNotat/createLaegekompetenceNotat";
import {KompetenceNotatList} from "../../../core/componentsPage/notat/kompetenceNotat/kompetenceNotatList";
import {forloebReducer, ForloebSliceState} from "../../../core/forloebSlice";
import {AsyncButton} from "../../../core/components/button/asyncButton";
import {NotatType} from "../../../core/sharedmodels/notat/notatType";
import {RoutePaths} from "../../../infrastructure/routes";
import DynamicButton, {DynamicButtonRoundedClasses, TextIconItem} from "core/components/button/dynamicButton";
import {EmblaIcons} from "core/emblaIcons";
import useUser from "core/hooks/useUser";
import useLogbogApi from "core/hooks/useLogbogApi";
import useStamdataApi from "core/hooks/useStamdataApi";
import {createPortal} from "react-dom";
import SpecialeSpecificKompetenceFilesList
    from "core/componentsPage/notat/kompetenceNotat/specialeSpecificKompetenceFilesList";
import useSpecialeSpecificFiles from "core/hooks/useSpecialeSpecificFiles";
import useLinkHistory from "infrastructure/route/useLinkHistory";
import {KompetenceEvalueringsskemaerOverview} from "../evaluering/kompetenceEvalueringsskemaerOverview";
import {appendCounter} from "../../../core/helpers/stringHelper";
import {ModalAcceptType, ModalSubmitMessage} from "../../../core/components/modalMessage/modalSubmitMessage";
import {SubmitModalInfo} from "../../../core/components/modalMessage/submitModalInfo";
import {NotificationModule} from "ditmer-embla";
import InfoBadgePill from "../../../core/components/badge/infoBadgePill";
import {showModalMessage} from "../../../core/components/modalMessage/modalMessage";
import useScreenResolution from "core/hooks/useScreenResolution";

export const kvTabIcon = EmblaIcons.ListQuestion;
export const NotatTabIcon = EmblaIcons.Comment;
export const SkemaTabIcon = EmblaIcons.Document;

const createLaegeKompetenceNotatSingleModalTarget = "kompetencenotat-current-kompetence-create-modal";
const afvisKlarmeldingModalTarget = "afvis-klarmelding-modal";

export type KompetenceOverviewProps = {
    laegeKompetenceId?: string;
    uddannelseslaegeId?: string;
    getAllRegardlessOfMaalbeskrivelse?: boolean;
    currentBrugerMaalbeskrivelse?: string;
    getCurrentBrugerMaalbeskrivelse?: (currentBrugerMaalbeskrivelse?: string) => void;
    isReadOnly?: boolean;
}

export const KompetenceOverview = (props: KompetenceOverviewProps) =>  {
    const { history } = useLinkHistory(); //Makes sure we automatically resets "linkState", if the user clicks "back"

    const dispatch = useDispatch();
    const { isMobile } = useScreenResolution();

    const { logbogExportApi, logbogLaegeKompetenceApi } = useLogbogApi();
    const { stamdataMaalbeskrivelseApi } = useStamdataApi();
    const { currentUser } = useUser();

    const forloebSliceState = useAppSelector(forloebReducer) as ForloebSliceState;
    const kompetenceCardState = useAppSelector(kompetenceCardReducer) as KompetenceCardState;
    const currentForloebState = useAppSelector(forloebReducer) as ForloebSliceState;

    const evaluationTabActive = isActiveTab(Localizer.global_evaluations(), kompetenceCardState.activeKompetencePageTabId ?? null);
    const notaterTabActive = isActiveTab(Localizer.global_notater(), kompetenceCardState.activeKompetencePageTabId ?? null);
    dispatch(scrollToActiveKompetence((evaluationTabActive || notaterTabActive) ?? false));

    const evaluationsHidden =
    !kompetenceCardState.activeLaegekompetenceMeta.hasActiveKvSkema &&
    kompetenceCardState.activeLaegekompetenceMeta.evalueringCount === 0;

    const [currentLaegekompetence, setCurrentLaegekompetence] = useState<LaegekompetenceMeta>(new LaegekompetenceMeta());
    const [isReadOnly, setIsReadOnly] = useState<boolean>(props.isReadOnly ?? false);
    const [brugerId, setBrugerId] = useState<string>();
    const [brugerMaalbeskrivelseId, setBrugerMaalbeskrivelseId] = useState<string>();
    const { allFileMetaData } = useSpecialeSpecificFiles(kompetenceCardState.activeLaegekompetenceMeta.kompetenceId, forloebSliceState.forloebState.regionId, kompetenceCardState.activeLaegekompetenceMeta.brugerMaalbeskrivelseId);
    
    // Determine initial tab: prioritize stored tab, then evaluations if available, else overview
    const getInitialTabId = () => {
        if (kompetenceCardState.activeKompetencePageTabId) {
            return kompetenceCardState.activeKompetencePageTabId;
        }
        const evaluationsAvailable = kompetenceCardState.activeLaegekompetenceMeta.hasActiveKvSkema || 
                                      kompetenceCardState.activeLaegekompetenceMeta.evalueringCount > 0;
        return evaluationsAvailable ? Localizer.global_evaluations() : Localizer.global_overview();
    };
    
    const [activeTabId, setActiveTabId] = useState<string | null>(getInitialTabId());
    const [showAfvisKlarmeldingModal, setShowAfvisKlarmeldingModal] = useState<boolean>(false);
    const [kommentar, setKommentar] = useState<string>();

    const getAllRegardlessOfMaalbeskrivelse = props.getAllRegardlessOfMaalbeskrivelse;
    const uddannelseslaegeId = props.uddannelseslaegeId;
    const laegeKompetenceId = props.laegeKompetenceId;

    const kompetenceKlarmeldtTilEnBruger = kompetenceCardState.activeLaegekompetenceMeta.klarmeldtTilIds?.length === 1;

    const [evalueringCount, setEvalueringCount] = useState<number>(kompetenceCardState.activeLaegekompetenceMeta.evalueringCount)

    const showAfvisklarmeldingBtn = kompetenceCardState.activeLaegekompetenceMeta.klarmeldtAt &&
        !kompetenceCardState.activeLaegekompetenceMeta.godkendtDato &&
        (kompetenceCardState.activeLaegekompetenceMeta.klarmeldtTilIds?.includes(currentUser.UserId) || kompetenceCardState.activeLaegekompetenceMeta.klarmeldtTilAlleMedAdgang) &&
        !currentUser.IsLaege();

    useEffect(() => {
        const fetchAndSetLaegeKompetence = async () => {
            const overviewKompetenceIsOnCurrentForloeb = uddannelseslaegeId === forloebSliceState.forloebState.brugerId;
            const overviewKompetenceDoesntMatchActiveKompetence = laegeKompetenceId !== kompetenceCardState.activeLaegekompetenceMeta.laegekompetenceId;

            if (!!laegeKompetenceId && !!uddannelseslaegeId && overviewKompetenceIsOnCurrentForloeb && overviewKompetenceDoesntMatchActiveKompetence) {
                const laegeKompetenceMeta = await logbogLaegeKompetenceApi.getLaegekompetenceById(laegeKompetenceId, uddannelseslaegeId);
                dispatch(setActiveLaegekompetenceMeta(laegeKompetenceMeta.ToState()));
            }
        }
        fetchAndSetLaegeKompetence();

    }, [dispatch, forloebSliceState.forloebState.brugerId, kompetenceCardState.activeLaegekompetenceMeta.laegekompetenceId, laegeKompetenceId, logbogLaegeKompetenceApi, uddannelseslaegeId])

    useEffect(() => {
        if (kompetenceCardState.activeLaegekompetenceMeta?.laegekompetenceId) {

            const hasChangedKompetence = kompetenceCardState.activeLaegekompetenceMeta?.laegekompetenceId !== currentLaegekompetence.laegekompetenceId && !!currentLaegekompetence.laegekompetenceId;
            if(hasChangedKompetence) {
                setActiveTabId(null);
            }

            setBrugerId(kompetenceCardState.activeLaegekompetenceMeta.UserId);
            setBrugerMaalbeskrivelseId(kompetenceCardState.activeLaegekompetenceMeta.brugerMaalbeskrivelseId);
            const laegekompetence = LaegekompetenceMeta.FromState(kompetenceCardState.activeLaegekompetenceMeta, currentForloebState.forloebState);
            setCurrentLaegekompetence(laegekompetence);

            if (!getAllRegardlessOfMaalbeskrivelse && !!forloebSliceState.forloebState.brugerMaalbeskrivelseId) {
                // Check if our active-kompetence is NOT on same "brugerMaalbeskrivelse" as our current forloeb:
                const lageKompetenceIsNotOnForloebBrugerMaalbeskrivelse = !!kompetenceCardState.activeLaegekompetenceMeta.brugerMaalbeskrivelseId && kompetenceCardState.activeLaegekompetenceMeta.brugerMaalbeskrivelseId !== forloebSliceState.forloebState.brugerMaalbeskrivelseId;
                setIsReadOnly(lageKompetenceIsNotOnForloebBrugerMaalbeskrivelse);
            }
            setEvalueringCount(laegekompetence?.evalueringCount)
        }
    }, [currentForloebState.forloebState, currentLaegekompetence.laegekompetenceId, forloebSliceState.forloebState.brugerMaalbeskrivelseId, getAllRegardlessOfMaalbeskrivelse, kompetenceCardState.activeLaegekompetenceMeta, stamdataMaalbeskrivelseApi])


    const tabCandidates = [
    { id: Localizer.global_evaluations(), hidden: evaluationsHidden },
    { id: Localizer.global_overview(), hidden: false },
    { id: Localizer.global_notes(), hidden: false },
    { id: Localizer.global_helpForms(), hidden: false },
    ];

    const firstVisibleTabId =
    tabCandidates.find(t => !t.hidden)?.id ?? null;

    useEffect(() => {
    if (!firstVisibleTabId) return;

    const activeIsVisible = tabCandidates.some(
        t => t.id === activeTabId && !t.hidden
    );

    if (!activeIsVisible) {
        setActiveTabId(firstVisibleTabId);
        dispatch(setActiveKompetencePageTab(firstVisibleTabId));
    }
    }, [activeTabId, firstVisibleTabId, evaluationsHidden, dispatch]);


    const tabs: Tab[] = [
        {
            hide: !kompetenceCardState.activeLaegekompetenceMeta.hasActiveKvSkema && kompetenceCardState.activeLaegekompetenceMeta.evalueringCount === 0,
            title: appendCounter(Localizer.global_evaluations(), evalueringCount),
            id: Localizer.global_evaluations(),
            defaultActive: isActiveTab(Localizer.global_evaluations(), activeTabId) ?? false,
            content: (<KompetenceEvalueringsskemaerOverview 
                laegeKompetence={currentLaegekompetence} 
                deleteKompetenceEvalueringCallback={() => {
                    setEvalueringCount(evalueringCount - 1)
                    // Refresh ping vil opdatere kompetnecetabellen og dermed antal evalueringer, men det vil resultere i tab-skift.
                    // Lader det være udkommenteret os må der kigges på dette hvis kunden vender tilbage
                    // dispatch(toggleLaegekompetenceListRefreshPing());
                }}
                onEvalueringCountLoaded={(count) => setEvalueringCount(count)}
            />),
            icon: kvTabIcon
        },
        {
            title: Localizer.global_overview(),
            id: Localizer.global_overview(),
            defaultActive: isActiveTab(Localizer.global_overview(), activeTabId) ?? false,
            content: <KompetenceDetails />
        }, {
            title: appendCounter(Localizer.global_notes(), currentLaegekompetence.notatCount),
            id: Localizer.global_notes(),
            defaultActive: isActiveTab(Localizer.global_notes(), activeTabId) ?? false,
            content: (<KompetenceNotatList />),
            icon: NotatTabIcon
        }, {
            title: appendCounter(Localizer.global_helpForms(), allFileMetaData.length),
            id: Localizer.global_helpForms(),
            defaultActive: isActiveTab(Localizer.global_helpForms(), activeTabId) ?? false,
            content: (<div className={"margin-m"}><SpecialeSpecificKompetenceFilesList files={allFileMetaData}/></div>),
            icon: SkemaTabIcon
        }
    ]

    const createLaegekompetenceNotat = () => {
        dispatch(setSlideinState({ state: SlideInStateEnum.Opened, slideInId: createLaegeKompetenceNotatSingleModalTarget }))
    }

    const getLaegekompetencePdf = (brugerId: string, brugerMaalbeskrivelseId: string) : Promise<void> => {
        return logbogExportApi.getPdfKompetence(currentLaegekompetence.laegekompetenceId, brugerId, brugerMaalbeskrivelseId);
    }

    const renderActionButtons = (isTabContent: boolean) => (
        <>
            {(!(kompetenceCardState.showCheckboxOnIds.length > 0) && !currentUser.IsKonsulentForLaegeligVidereuddannelse() && brugerId) &&
                <div className={`flex-container flex-space-around margin-bottom-xs ${isMobile ? "margin-left-xs margin-right-xs" : ""}`}>
                    {brugerId && brugerMaalbeskrivelseId &&
                        <AsyncButton
                            clickFunction={() => getLaegekompetencePdf(brugerId, brugerMaalbeskrivelseId)}
                            waitText={Localizer.gettingPdf()}
                            additionalClasses={isMobile ? DynamicButtonRoundedClasses : undefined}
                            child={<TextIconItem iconName={EmblaIcons.Incoming} text={Localizer.GetPdf()}/>}
                            role={isTabContent ? "tab" : "button"}
                            ariaLabel={Localizer.GetPdf()}
                        />
                    }

                    { !currentUser.IsSekretaer() &&
                        <DynamicButton
                            onClick={createLaegekompetenceNotat}
                            disabled={kompetenceCardState.activeLaegekompetenceMeta.godkendtDato !== undefined}
                            modal={{ dataTarget: `#${createLaegeKompetenceNotatSingleModalTarget}` }}
                            role={isTabContent ? "tab" : "button"}
                            ariaLabel={Localizer.notatPage_createNotat()}
                        >
                            <DynamicButton.TextIconItem iconName={EmblaIcons.DocumentAdd} text={Localizer.notatPage_createNotat()} />
                        </DynamicButton>
                    }
                    {showAfvisklarmeldingBtn &&
                        <DynamicButton 
                            onClick={() => {
                                setShowAfvisKlarmeldingModal(true)
                                showModalMessage(afvisKlarmeldingModalTarget)
                            }}
                            role={isTabContent ? "tab" : "button"}
                            ariaLabel={Localizer.klarmeldingerPage_afvisKlarmelding()}
                        >
                            <DynamicButton.TextIconItem iconName={EmblaIcons.Remove} text={Localizer.klarmeldingerPage_afvisKlarmelding()} />
                        </DynamicButton>
                    }

                    {/* Right now we use "LaegekompetenceListRefreshPing" here - in future we should patch card-list state */}
                    <KompetenceStatusButton 
                        key={brugerId} 
                        brugerId={brugerId} 
                        onSucceded={() => dispatch(toggleLaegekompetenceListRefreshPing())} 
                        role={isTabContent ? "tab" : "button"}
                    />
                </div>
            }
        </>
    )

    const createNotatSlideInFinishedCallback = () => {
        dispatch(scrollToActiveKompetence(true));
        dispatch(setActiveLaegekompetenceMeta({ notatCount: kompetenceCardState.activeLaegekompetenceMeta.notatCount + 1 }));
        dispatch(toggleLaegekompetenceNotatChangedPing());
        dispatch(toggleLaegekompetenceListRefreshPing()) //Was inside "CreateLaegeKompetenceNotat" before (now just here) - todo: remove it, when we can patch the state.
    }

    function renderKompetenceReadOnlyContent() {
        return <div className="d-flex flex-column">
            <div className="alert alert-warning margin-right-m margin-left-m">
                <b>{Localizer.kompetencePage_foraeldetKompetence()}</b> <br/>
                {Localizer.kompetencePage_foraeldetKompetenceBeskrivelse()} <br/>
                <button className="btn btn-default btn-round margin-top-s margin-bottom-s"
                        onClick={() => !isMobile ? props.getCurrentBrugerMaalbeskrivelse?.(props.currentBrugerMaalbeskrivelse) : history.push(RoutePaths.Kompetencer({uddannelseslaege: currentForloebState.forloebState.brugerId}).url)}>
                    <b>{Localizer.kompetencePage_gaaTilAktivMaalbeskrivelse()}</b>
                </button>
            </div>
        </div>;
    }

    const afvisKlarmelding = async () => {
        const afvistLaegekompetenceId = await logbogLaegeKompetenceApi.afvisKlarmelding(kompetenceCardState.activeLaegekompetenceMeta.laegekompetenceId, kompetenceCardState.activeLaegekompetenceMeta.UserId, kommentar)
        if (afvistLaegekompetenceId) {
            dispatch(setSlideinState({state: SlideInStateEnum.Closing, slideInId: afvisKlarmeldingModalTarget}))
            dispatch(toggleLaegekompetenceListRefreshPing())
            NotificationModule.showSuccess(Localizer.klarmeldingerPage_laegekompetenceKlarmeldingAfvist(), "");
        }
        else
            dispatch(setSlideinState({state: SlideInStateEnum.Opened, slideInId: afvisKlarmeldingModalTarget}))

    }

    const handleCommentChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setKommentar(e.target.value)
    }

    return (
        <>
            {(!!currentLaegekompetence?.laegekompetenceId && !!kompetenceCardState.activeLaegekompetenceMeta?.laegekompetenceId) &&
                <>
                    <div className="d-flex flex-column">
                        <h3 className="margin-m">{currentLaegekompetence.fullKompetenceTitleWithNumber}</h3>

                        {isReadOnly &&
                            renderKompetenceReadOnlyContent()
                        }

                        {(isMobile && !isReadOnly) &&
                            renderActionButtons(false)
                        }

                        <Tabs
                            tabs={tabs}
                            setActiveCallback={(activeTabId) => {
                                setActiveTabId(activeTabId);
                                dispatch(setActiveKompetencePageTab(activeTabId));
                            }}
                            navTabRightSideContent={(!isMobile && !isReadOnly) ? renderActionButtons(true) : undefined}
                        />
                    </div>
                </>
            }

            {currentLaegekompetence.laegekompetenceId !== undefined &&
                // Fix scroll-problems with "CreatePortal"
                createPortal(
                    <SlideIn
                        key={currentLaegekompetence.laegekompetenceId}
                        id={createLaegeKompetenceNotatSingleModalTarget}
                        title={Localizer.notatPage_createNotat()}
                        actionText={Localizer.notatPage_creatingNotat()}
                        bodyContent={<CreateLaegekompetenceNotat modalId={createLaegeKompetenceNotatSingleModalTarget} laegekompetencer={[currentLaegekompetence]} notatType={NotatType.Kompetence}/>}
                        actionFinishedCallback={createNotatSlideInFinishedCallback}
                    />,
                    document.body
                )
            }

            {showAfvisKlarmeldingModal &&
                createPortal(
                <ModalSubmitMessage
                    title={Localizer.klarmeldingerPage_afvisKlarmelding()}
                    modalId={afvisKlarmeldingModalTarget}
                    acceptAction={afvisKlarmelding}
                    acceptButtonText={Localizer.klarmeldingerPage_afvisKlarmelding()}
                    defaultOpen={true}
                    tooltipTitle={kompetenceKlarmeldtTilEnBruger && !kommentar ? Localizer.klarmeldingerPage_kommentarTilAfvisningAfKlarmeldingPaakraevet() : undefined}
                    acceptButtonDisabled={kompetenceKlarmeldtTilEnBruger && !kommentar}
                    modalAcceptType={ModalAcceptType.danger}
                    description={
                        <>
                            <SubmitModalInfo handleCommentChange={handleCommentChange}
                                             tekst={Localizer.klarmeldingerPage_afvisKlarmeldingDescription()}
                                             commentPlaceholderText={kompetenceKlarmeldtTilEnBruger ? Localizer.klarmeldingerPage_kommentarTilAfvisningAfKlarmeldingRequired() : Localizer.klarmeldingerPage_kommentarTilAfvisningAfKlarmelding()}
                            />
                            <div className="margin-top-m flex-container-column wrap">
                                <h6 className={"font-weight-bold"}>
                                    {Localizer.global_klarmeldtden() + kompetenceCardState.activeLaegekompetenceMeta.klarmeldtAt} {Localizer.global_to().toLowerCase()}:
                                </h6>
                                <div className="flex-row">
                                    {kompetenceCardState.activeLaegekompetenceMeta.klarmeldtTilNavn?.length === 0
                                        ?
                                            <InfoBadgePill badgeType={"badge-default"} badgeText={Localizer.global_none()}/>
                                        :
                                        kompetenceCardState.activeLaegekompetenceMeta.klarmeldtTilNavn?.map(navn =>
                                            <InfoBadgePill badgeType={"badge-default"} badgeText={navn}/>
                                    )}
                                </div>
                            </div>
                        </>
                    }
                    cancelAction={() => {
                        setShowAfvisKlarmeldingModal(false)
                    }}
                />, document.body)
            }
        </>
    );
}
